/* External */
import React from 'react';
import PropTypes from 'prop-types';

/* Components */
import MenuButton from '../MenuButton/MenuButton';

/* Styles */
import './EpgButton.scss';
import { getVrioImageUrl } from '../../../../utils';

function EpgButton({
  channelLogo,
  openEpgHandler,
}) {
  return (
    <MenuButton
      onClick={() => openEpgHandler({ option: 'epg_zapping_option_one' })}
      showOnClick={false}
      buttonContent={(
        <div className="dtv-epg-content-button">
          <img
            src={getVrioImageUrl(channelLogo, '4:3', { width: 50, height: 37 })}
            alt=""
            className="dtv-dock-icon"
          />
        </div>
        )}
      className="dtv-common-c-epg-button"
      id="btn-open-epg-zapping-option_1"
    />
  );
}

EpgButton.propTypes = {
  channelLogo: PropTypes.string,
  openEpgHandler: PropTypes.func,
};

EpgButton.defaultProps = {
  channelLogo: '',
  openEpgHandler: () => {},
};

export default EpgButton;
